import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import {
  DsInlineAlertComponent,
  DsModalBottomSheetComponent,
} from '@customdesignsystem';
import { CheckModalIconComponent } from 'src/assets/cambio-via-pago-pension/icons/svg/check-modal/check_modal.component';
import { CloseModalIconComponent } from 'src/assets/cambio-via-pago-pension/icons/svg/close-modal/close_modal.component';
import { InfoModalIconComponent } from 'src/assets/cambio-via-pago-pension/icons/svg/info-modal/info_modal.component';
import { CargandoTramiteIconComponent } from 'src/assets/tramite-pension/icons/svg/cargando/cargando.component';
import { CheckCircleTramiteIconComponent } from 'src/assets/tramite-pension/icons/svg/check-circle/check-circle.component';
import { InfoCircleTramiteIconComponent } from 'src/assets/tramite-pension/icons/svg/i-circle/i-circle.component';
import { InfoStemTramiteIconComponent } from 'src/assets/tramite-pension/icons/svg/i-circle/i-stem-dot.component';
import { WarningTramiteIconComponent } from 'src/assets/tramite-pension/icons/svg/warning/warning.component';
import { InformacionSvgComponent } from '../cambio-via-pago-pension/core/assets/informacion/informacion.component';
import {
  GenericErrorComponent,
  GenericModalComponent,
  GenericModalWithSubtitleComponent,
  InformationModalComponent,
  ModalPasosTramitePensionComponent,
  RightSideInfoColumnComponent,
  StepperComponent,
} from './components';
import { DownloadMessageComponent } from './components/download-message/download-message.component';
import { DropdownComponent } from './components/dropdown';
import { DropdownNewDesignComponent } from './components/dropdown-new-design/dropdown-new-design.component';
import { FaqCardComponent } from './components/faq-card';
import { GenericModalSalirPaginaComponent } from './components/generic-modal-salir-pagina';
import { MensajeImportanteComponent } from './components/mensaje-importante/mensaje-importante.component';
import { ModalReformaTramitePensionComponent } from './components/modal-reforma-tramite-pension/modal-reforma-tramite-pension.component';
import { ModalValidarCuentasComponent } from './components/modal-validar-cuentas/modal-validar-cuentas.component';
import { ModalVideoIppComponent } from './components/modal-video-ipp/modal-video-ipp.component';
import { OutlineInputComponent } from './components/outline-input';
import { PreguntasComponent } from './components/preguntas';
import { PreguntasIngresoExtraComponent } from './components/preguntas-ingreso-extra';
import { SolicitudErrorComponent } from './components/solicitud-error/solicitud-error.component';
import { StepperDotsComponent } from './components/stepper-dots';
import { VoucherComponent } from './components/voucher';
import { TooltipInfoDirective } from './directives/tooltip-info.directive';
import { FormatPeriodoInformePensionesPipe } from './pipes/format-periodo-informe-pensiones.pipe';
import { FormatPhoneNumberPipe } from './pipes/format-phone-number.pipe';

const COMPONENTS = [
  StepperComponent,
  InformationModalComponent,
  GenericModalComponent,
  GenericModalWithSubtitleComponent,
  ModalValidarCuentasComponent,
  InformacionSvgComponent,
  VoucherComponent,
  SolicitudErrorComponent,
  OutlineInputComponent,
  StepperDotsComponent,
  DropdownNewDesignComponent,
  MensajeImportanteComponent,
  RightSideInfoColumnComponent,
  FaqCardComponent,
  DownloadMessageComponent,
  CloseModalIconComponent,
  InfoModalIconComponent,
  CheckModalIconComponent,
  ModalReformaTramitePensionComponent,
  ModalVideoIppComponent  
];

const STANDALONE_COMPONENTS = [
  PreguntasComponent,
  PreguntasIngresoExtraComponent,
  DsModalBottomSheetComponent,
  DsInlineAlertComponent,
];

const MODULES = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  IonicModule,
  RouterModule,
  DropdownComponent,
  GenericErrorComponent,
  GenericModalSalirPaginaComponent,
  ModalPasosTramitePensionComponent,
  CheckCircleTramiteIconComponent,
  InfoCircleTramiteIconComponent,
  InfoStemTramiteIconComponent,
  WarningTramiteIconComponent,
  ReactiveFormsModule,
  TooltipInfoDirective,
  CargandoTramiteIconComponent
];

const PIPES = [
  FormatPhoneNumberPipe,
  FormatPeriodoInformePensionesPipe
];

@NgModule({
  imports: [
    ...MODULES,
    ...STANDALONE_COMPONENTS
  ],
  declarations: [...COMPONENTS, ...PIPES],
  exports: [...MODULES, ...COMPONENTS, ...PIPES, ...STANDALONE_COMPONENTS],
})
export class SharedModule { }